import { getRailsClient } from "../client";
import { prepareApiRoute } from "../helpers/routeHelpers";

import { Lesson, VisitedTabs } from "./types/lessonTypes";
import { Assessment } from "./types/quizTypes";

const ApiRoute = "/api/internal_api/atlas/v1/lessons/:lesson_key/full";

export interface LessonAttemptResponse {
  type?: string;
  areNotesOpen: boolean;
  lesson: Lesson;
  levelName: string;
  roleName: string;
  assessment: Assessment;
  experimentStatus: any;
  passedAnotherVersion: boolean;
  noMoreAttempts: boolean;
  resourcesNumber: number;
  visitedTabs: VisitedTabs;
  isConsumed: boolean;
  watchedVideo: boolean;
  readTranscript: boolean;
  learnedExternal: boolean;
}

export const fetchLessonAttempt = async (lessonKey: string): Promise<LessonAttemptResponse> => {
  const client = getRailsClient();
  const route = prepareApiRoute(ApiRoute, { lesson_key: lessonKey });
  const { data }: { data: LessonAttemptResponse } = await client.get(route);

  // Add "type" based on data
  if (data.lesson.isBreakFixLesson) {
    switch (data.lesson.lessonGroupContext) {
      case "hacking_challenge":
        data.type = "Hacking Challenge";
        break;
      case "coding_challenge":
        data.type = "Coding Challenge";
        break;
      default:
        data.type = "Break/Fix Lesson";
        break;
    }
  } else {
    if (data.lesson.hasExperiment) {
      data.type = "Video w/ Exercise";
    } else {
      data.type = "Video";
    }
  }

  return data;
};
